import { CORPORATE_LEAD } from "./type";

const initalState = {
  createLeadData: [],
};

const coporateLeadReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CORPORATE_LEAD:
      return {
        ...state,
        createLeadData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default coporateLeadReducer;
